import React, { useContext, useState } from 'react';
import { Workspace } from 'src/common/models/common-types';
import { Box, Button, Typography } from '@mui/material';
import { i18n } from 'src/common/i18n/i18n';
import { GlobalContext } from 'src/common/contexts/globalContext';
import WorkspacesSelectionMenu from '../WorkspacesSelectionMenu/WorkspacesSelectionMenu';
import { COLORS } from 'src/common/constants/constants';
import { IconArrowUp, IconArrowDown } from 'src/common/images';
import { removeParam } from 'src/common/utils/communication';
import Popup from '../../../../../../common/components/Popup/Popup';
import { Tooltip } from '@cellebrite/saas-ui-common';

const WorkspaceInfo = () => {
    const { workspacesData, casesData } = useContext(GlobalContext);
    const [actionsOpen, setActionsOpen] = useState(false);
    const onChangeWorkspace = (ws: Workspace) => {
        if (ws.id !== workspacesData.activeWorkspace?.id) {
            removeParam('caseId');
            casesData.setActiveCase(null);
            workspacesData.setActiveWorkspace(ws);
        }
    };
    return (
        <div style={{ display: 'flex' }}>
            {!!workspacesData.workspaces?.length && (
                <Popup
                    onToggle={() => setActionsOpen(!actionsOpen)}
                    actionElement={(handleOpen, anchorReference, open) => (
                        <Tooltip
                            placement="bottom"
                            content={
                                <>
                                    <Typography>
                                        {i18n.translate('Current workspace')}:{' '}
                                        <b>
                                            {workspacesData.activeWorkspace
                                                ? workspacesData.activeWorkspace.name
                                                : i18n.translate('Loading')}
                                        </b>
                                    </Typography>
                                    <Typography>{i18n.translate('Switch workspace')}</Typography>
                                </>
                            }
                        >
                            <Button
                                ref={anchorReference}
                                color="tetriary"
                                onClick={handleOpen}
                                sx={{
                                    backgroundColor: open ? COLORS.BRAND_LIGHTEST : null,
                                    padding: '4px 8px',
                                    maxHeight: 'unset',
                                    width: 'max-content',
                                }}
                            >
                                <Box
                                    sx={{ mr: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
                                >
                                    <Typography className="color-md" variant="s14w500">
                                        {i18n.translate('Workspace')}
                                    </Typography>
                                    <Typography className="color-bd">
                                        {workspacesData.activeWorkspace
                                            ? workspacesData.activeWorkspace.name
                                            : i18n.translate('Loading')}
                                    </Typography>
                                </Box>
                                {open ? <IconArrowUp className="fill-md" /> : <IconArrowDown className="fill-md" />}
                            </Button>
                        </Tooltip>
                    )}
                    contentElement={(handleClose) => {
                        return (
                            <Box>
                                <WorkspacesSelectionMenu
                                    activeWorkspace={workspacesData.activeWorkspace}
                                    onChangeWorkspace={onChangeWorkspace}
                                    workspaces={workspacesData.workspaces}
                                    onCloseCallback={handleClose}
                                />
                            </Box>
                        );
                    }}
                />
            )}
        </div>
    );
};

export default WorkspaceInfo;
